import { mString } from 'lib/helpers/utility';

const handleBoolean = (val) => (val ? 'Yes' : 'No');
const handleObject = (obj) =>
  Object.keys(obj)
    .map((key) => `${formatLabel(key)} - ${renderValue(key, obj[key])}`)
    .join('<br/>');

const AMOUNT_KEYS = ['amount'];

export const renderValue = (key, value) => {
  if (Array.isArray(value)) {
    return value
      .map((item) => {
        if (typeof item === 'object' && item !== null) {
          return handleObject(item);
        }
        if (typeof item === 'boolean') {
          return handleBoolean(item);
        }

        return item || 'blank';
      })
      .join('\n');
  }

  if (typeof value === 'object' && value !== null) {
    return handleObject(value);
  }

  if (typeof value === 'boolean') {
    return handleBoolean(value);
  }

  if (AMOUNT_KEYS.some((field) => key.includes(field))) {
    return mString(value);
  }

  return value || 'blank';
};

export const formatLabel = (key) => {
  if (typeof key === 'object' && key !== null) {
    return Object.keys(key).reduce((acc, nestedKey) => {
      acc[formatLabel(nestedKey)] = formatLabel(key[nestedKey]);
      return acc;
    }, {});
  }
  return key
    .replace(/_/g, ' ')
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase());
};
